import * as types from "./actionTypes"

const initialState = {
    station: "",
    track: "",
    success: false,
    failure: false,
    fetchSuccess: false,
    cars: [],
}

export default function carOrdersReducer(state = initialState, action) {
    switch (action.type) {
        case types.GET_RESEQUENCE_CARS:
            return {
                ...state,
                station: action.data.station,
                track: action.data.track,
            }
        case types.GET_RESEQUENCE_CARS_SUCCESS:
            return {
                ...state,
                fetchSuccess: true,
                cars: action.data,
            }
        case types.CLEAR_RESEQUENCE_CARS:
            return {
                ...initialState,
                fetchSuccess: false,
                cars: [],
            }
        case types.RESEQUENCE_SUCCESS:
            return {
                ...state,
                success: true,
            }

        case types.RESEQUENCE_FAILURE:
            return {
                ...state,
                failure: true,
            }

        case types.RESEQUENCE_RESET:
            return {
                ...initialState,
                success: false,
                failure: false,
                fetchSuccess: false,
            }

        default:
            return state
    }
}
